// extracted by mini-css-extract-plugin
export var card = "_mo-5";
export var cardSelected = "_mo-4";
export var image = "_mo-3";
export var modal = "_mo-0";
export var modalContent = "_mo-1";
export var table = "_mo-2";